@if (!searchable) {
  <!-- Original select mode -->
  <mat-form-field customColor="light" appearance="outline" [class.variant-primary]="color === 'primary'" [class.without-hint]="withoutHint">
    <mat-label>{{ label }}</mat-label>
    <mat-select [formControl]="control" [placeholder]="placeholder" [disabled]="disabled" [panelClass]="panelClasses">
      @for (option of options; track option.value) {
        <mat-option [value]="option.value">
          {{ option.viewValue }}
        </mat-option>
      }
    </mat-select>
    @if (control?.invalid && control?.errors) {
      <mat-error>{{ errorLabel }}</mat-error>
    }
  </mat-form-field>
} @else {
  <!-- Searchable autocomplete mode -->
  <mat-form-field
    customColor="light"
    appearance="outline"
    class="searchable-field"
    [class.variant-primary]="color === 'primary'"
    [class.without-hint]="withoutHint"
  >
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      [matAutocomplete]="auto"
      [formControl]="searchControl"
      placeholder="Buscar"
      title="Buscar"
      aria-label="Buscar"
      [placeholder]="placeholder"
      [attr.aria-label]="label || placeholder"
      [attr.title]="label || placeholder"
      autocomplete="off"
      [disabled]="disabled"
    />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)" class="select-autocomplete">
      @for (option of (filteredOptions$ | async) || []; track option.value) {
        <mat-option [value]="option">
          {{ option.viewValue }}
        </mat-option>
      } @empty {
        <mat-option disabled> No hay resultados </mat-option>
      }
    </mat-autocomplete>
    @if (control?.invalid && control?.errors) {
      <mat-error>{{ errorLabel }}</mat-error>
    }
  </mat-form-field>
}
